import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const getTiktokAccount = createAsyncThunk('tiktok/getAccount', async ({ accountId, domainId }) => {
  const response = await fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/tiktok/account`);
  return await response.json();
});

export const tiktokSlice = createSlice({
  name: 'tiktok',
  initialState: {
    account: null,
    loading: null,
    error: null,
  },
  reducers: {
    setTiktokAccount: (state, action) => {
      state.account = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTiktokAccount.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getTiktokAccount.fulfilled, (state, action) => {
        const account = action.payload.tiktokAccount;
        state.account = account;
        state.loading = false;
      })
      .addCase(getTiktokAccount.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export const { setTiktokAccount } = tiktokSlice.actions;

export default tiktokSlice.reducer;
